import { User, UserSettings } from '@models/core';
import { MenuItem, MenuModel } from '@models/menu';
import { ContextInfo } from '@system/context/context.model';
import { A11yPreferences, Theme } from '../services/helpers.store';

// Temporary sollution until context refactoring
export type UserWithLastContractContext = User & {
  lastContractContext?: ContextInfo;
};

export enum DialogClosed {
  Contract = 'contract',
  EmailSent = 'emailSent',
  ModuleSettings = 'moduleSettings',
  DmImport = 'dmImport',
  DmTransitionEnd = 'dmTransitionEnd',
  DmAssignmentChanged = 'dmAssignmentChanged',

  SovTransitionForm = 'sovTransitionForm',
  SovImport = 'sovImport',
  SovItem = 'sovItem',
  SovCancel = 'sovCancel',
  SovAdd = 'sovAdd',

  PPAdd = 'ppAdd',
  PPCancel = 'ppCancel',
  PdfMarkupAdd = 'pdfMarkupAdd',
}

export type UserState = {
  userData: UserWithLastContractContext;
  menu: {
    isCollapsed: boolean;
    items: MenuModel[];
    activeMenuItem: MenuItem;
  };
  reloadContext?: boolean;
  isLoading: boolean;
  angularJsRoute: boolean;
  hideHeader?: boolean;
  unreadNotifications?: number;
  devMode: boolean;
  theme: Theme;
  a11y: A11yPreferences;
  language?: string;
  isSmallScreen?: boolean;
  settings: UserSettings;

  //   Temporary prop used for tracking close event of the dialog from js
  dialogData?: unknown;

  cipoAI: {
    assistantOpened: boolean;
  };
};

export const initialUserState: UserState = {
  userData: null,
  menu: {
    isCollapsed: false,
    items: [],
    activeMenuItem: null,
  },
  isLoading: false,
  angularJsRoute: false,
  reloadContext: false,
  hideHeader: false,
  unreadNotifications: 0,
  devMode: false,
  theme: {
    color: 'default',
    mode: 'light',
  },
  a11y: {
    contrast: 'normal',
    reduceMotion: false,
    fontScale: 'normal',
    textSpacing: 'normal',
    lineHeight: 'normal',
    saturation: 'normal',
    underlineLinks: false,
    dyslexiaFont: false,
    colorFilter: 'normal',
    largeCursor: false,
    readingAid: 'off',
  },
  language: 'en-US',
  settings: undefined,
  isSmallScreen: false,
  dialogData: null,
  cipoAI: {
    assistantOpened: false,
  },
};

export enum UserStoreActions {
  SetActiveMenuItem = '[User Store] SetActiveMenuItem',
  SetMenuItems = '[User Store] SetMenuItems',
  SetContractId = '[User Store] SetUserContractId',
  SetUserContext = '[User Store] SetUserContext',
  LoadingUserData = '[User Store] LoadingUserData',
  LoadingUserDataFailed = '[User Store] LoadingUserDataFailed',
  SetUserDataAndMenu = '[User Store] SetUserDataAndMenu',
  SetUserData = '[User Store] SetUserData',
  SetUserRolesOnCurrentContract = '[User Store] SetUserRolesOnCurrentContract',
  SetSettings = '[User Store] SetUserSettings',
  SetNotifications = '[User Store] SetUserNotifications',
  ToggleLoading = '[User Store] ToggleLoading',
  CollapseMenu = '[User Store] CollapseMenu',
  EnableDemo = '[User Store] EnableDemo',
  SetReloadContext = '[User Store] SetReloadContext',
  SetContextWithContract = '[User Store] SetContextWithContract',
  SetContextWithoutContract = '[User Store] SetContextWithoutContract',
  SetAngularJsRoute = '[User Store] SetAngularJsRoute',
  SetHideHeader = '[User Store] SetHideHeader',
  CloseJsDialog = '[User Store] CloseJsDialog',
  setLanguage = '[User Store] SetLanguage',
  setSmallScreen = '[User Store] SetSmallScreen',
  setTheme = '[User Store] SetTheme',
  setA11y = '[User Store] SetA11y',
  SetAssistantOpened = '[User Store] SetAssistantOpened',
}
